import { FC } from 'react';
import { useIntl } from 'react-intl';

import { Modal } from '@/shared/ui';

import type { DocumentTemplateParseResponse } from '@/entities/templates';

import { templateEditorMessages } from '../../config';
import type { ImportStrategy } from '../../config';
import { ImportSourcePanel } from '../ImportSourcePanel';

import styles from './ImportTemplateModal.module.scss';

type ImportTemplateModalProps = {
  isOpen: boolean;
  hasExistingSections: boolean;
  onApplyJson: (content: string, strategy: ImportStrategy) => boolean;
  onClose: () => void;
  onParsed: (
    result: DocumentTemplateParseResponse,
    sourceContent: string,
    strategy: ImportStrategy,
  ) => void;
};

export const ImportTemplateModal: FC<ImportTemplateModalProps> = (props) => {
  const { isOpen, hasExistingSections, onApplyJson, onClose, onParsed } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      borderless
      title={formatMessage(templateEditorMessages.importModalTitle)}
      hideFooter
      onCancel={onClose}
    >
      <ImportSourcePanel
        className={styles.panel}
        hasExistingSections={hasExistingSections}
        onApplyJson={onApplyJson}
        onParsed={onParsed}
        onCancel={onClose}
      />
    </Modal>
  );
};
